import React from 'react'
import propTypes from 'prop-types'
import DataGrid from '../../common/apsys.datagrid.materialui/DataGrid'
import { Paper, Typography } from '@material-ui/core'
import SearchBox from '../../common/SearchToolbox'
import { useDesktopViewStyles } from '../resources/NetworkDayStyles'

/**
 * CustomersNetworkDays weeks
 */
const CustomersNetworkDays = (props) => {
	const classes = useDesktopViewStyles()

	const getHeaderTableConfig = () => {
        let nameProperty = headersTableConfig.find((x) => x.dataSource === 'Name')
        nameProperty.onRenderProperty = (item) => {
            return <Typography className={classes.textTable}>{item.Name}</Typography>
        }

		let averageProperty = headersTableConfig.find((x) => x.dataSource === 'Average')
        averageProperty.onRenderProperty = (item) => {
            return <Typography className={classes.textTable}>{item.Average}</Typography>
        }
		let maximumProperty = headersTableConfig.find((x) => x.dataSource === 'Maximum')
        maximumProperty.onRenderProperty = (item) => {
            return <Typography className={classes.textTable}>{item.Maximum}</Typography>
        }
		let countProperty = headersTableConfig.find((x) => x.dataSource === 'Count')
        countProperty.onRenderProperty = (item) => {
            return <Typography className={classes.textTable}>{item.Count}</Typography>
        }
        return headersTableConfig
    }

	/**
	 * Return component
	 */
	return (
		<Paper className={classes.contentProviderTablePaper}>
			<div className={classes.search}>
				<Typography variant='subtitle1' className={classes.titleColor}>Customers</Typography>
				<div className={classes.grow} />
				<SearchBox
					placeholder='Search'
					onChange={props.onQueryCustomerChange}
					value={props.searchValue}
				/>
			</div>
			<div className={classes.containerTable}>
				<DataGrid
					data={props.customers}
					headers={getHeaderTableConfig()}
					sortBy={props.sortingCriteria.by}
					sortDirection={props.sortingCriteria.direction}
					onChangeSortingCriteria={props.onChangeSortingCriteria}
					onItemClick={(sender, customer) => props.onCustomerClick(customer)}
				/>
			</div>
		</Paper>
	)
}
CustomersNetworkDays.propTypes = {
	/**
	 * The service  provider list
	 */
	customers: propTypes.arrayOf(
		propTypes.shape({
			Name: propTypes.string.isRequired,
			Minimum: propTypes.number.isRequired,
			Average: propTypes.number.isRequired,
			Maximum: propTypes.number.isRequired,
			Count: propTypes.number.isRequired
		})
	),
	/**
	 * The service providers sorting criteria
	 */
	sortingCriteria: propTypes.shape({
		by: propTypes.string.isRequired,
		direction: propTypes.string.isRequired
	}).isRequired,
	/**
	 * Callback executed when the sorting criteria change
	 */
	onChangeSortingCriteria: propTypes.func.isRequired,
	/**
	 * Callback executed when the user click on a service provider
	 */
	onCustomerClick: propTypes.func,
	/**
	 * Callback executed when the search service provider change
	 */
	onQueryCustomerChange: propTypes.func,
}
CustomersNetworkDays.defaultProps = {
	customers: [],
	onChangeSortingCriteria: () => console.warn("No [onChangeSortingCriteria] callback defined"),
	onQueryCustomerChange: () => console.warn("No [onQueryCustomerChange] callback defined")
}
export default CustomersNetworkDays

const headersTableConfig = [
	{
		title: 'Name',
		dataSource: 'Name',
		sortable: true
	},
	{
		title: 'Avg',
		dataSource: 'Average',
		sortable: true
	},
	{
		title: 'Max',
		dataSource: 'Maximum',
		sortable: true
	},
	{
		title: 'Count',
		dataSource: 'Count',
		sortable: true
	}
]
